import { createTheme, StyledEngineProvider, ThemeProvider } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';

const theme = createTheme();

// Nothing here renders MUI directly — this exists for @eventmobi/widgets.
// `@mui/styles` falls back to an empty theme object, so the widget stylesheets
// that read `theme.spacing` throw without a provider above them. `injectFirst`
// keeps emotion ahead of those sheets in <head>, so the widgets' own rules win.
const MuiProvider = ({ children }) => (
  <StyledEngineProvider injectFirst>
    <ThemeProvider theme={theme}>{children}</ThemeProvider>
  </StyledEngineProvider>
);

MuiProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MuiProvider;
